<p>push-notification works!!</p>
<input type="file" [(ngModel)]="file" (change)="fileChanged($event)" />

<button type="button" class="btn btn-primary" (click) = "sendNotification()">Notify</button>
